import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbarNotification } from '../../shared/tools/notifications/useSnackbarNotification'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { clearAuth } from '@/containers/Login/AuthSlice'

export const useNotificationReceivedListener = () => {
  const showNotification = useSnackbarNotification()
  const { t } = useTranslation()
  const { userId, sessionExpiration, authTokenSessionId } = useSelector(selectAuthData)
  const dispatch = useDispatch()
  const [gamificationNotification, setGamificationNotification] = useState(null)

  const handleLogout = message => {
    dispatch(clearAuth())

    const showAlertAndRedirect = () => {
      alert(message)
      location.assign('/login')
    }

    if (document.hasFocus()) {
      showAlertAndRedirect()
    } else {
      const handleFocus = () => {
        showAlertAndRedirect()
        window.removeEventListener('focus', handleFocus)
      }
      window.addEventListener('focus', handleFocus)
    }
  }

  useEffect(() => {
    window.Echo.channel('notifications.connected-users').listen('.notification.received', event => {
      showNotification({
        type: event.type,
        message: event.isCustomMessage ? event.message : t('common:notifications.' + event.message),
      })
    })
  }, [])

  useEffect(() => {
    window.Echo.channel('gamification-user-level-change.' + userId).listen('.operation.success', event => {
      const { status, new_level, achievement_name, sales_count, sales_count_before } = event.data
      const translationParams = {
        level: new_level,
        achievement: achievement_name,
        sales_count,
        sales_count_before,
      }

      const typeMap = { level_up: 'success', level_down: 'warning', equal_level: 'info' }
      const notificationType = typeMap[status] || 'info'
      const message = t(`gamification:${status}_notification`, translationParams)

      setGamificationNotification({ type: notificationType, message })
      // trigger gamification data refresh for any listening component
      window.dispatchEvent(new CustomEvent('gamification-update'))
    })
  }, [userId])

  useEffect(() => {
    const checkSessionExpiration = () => {
      const currentDate = new Date()
      const date = new Date(currentDate.toLocaleString('en-US', { timeZone: 'Europe/Paris' }))
      console.log('Check session - end - current:', sessionExpiration, ' -- ', date)
      if (sessionExpiration && date > sessionExpiration) {
        handleLogout(t('common:notifications.session_expired'))
      }
    }

    const interval = setInterval(checkSessionExpiration, 1800000) // Check every 30 minutes
    return () => clearInterval(interval)
  }, [sessionExpiration])

  useEffect(() => {
    window.Echo.channel('user.status.' + userId).listen('.operation.success', e => {
      console.log('notification Success:', e)
      if (parseInt(e.id) !== parseInt(userId) || parseInt(e.data.status) !== 0) {
        return
      }
      handleLogout(t('common:notifications.user_deactivated'))
    })
  }, [userId])

  useEffect(() => {
    window.Echo.channel('api-token-disconnect.' + authTokenSessionId).listen('.operation.success', e => {
      handleLogout(t('common:notifications.session_disconnected'))
    })
  }, [authTokenSessionId])

  return {
    gamificationNotification,
    clearGamificationNotification: () => setGamificationNotification(null),
  }
}
